module.exports = __webpack_public_path__ + "static/media/post-it-notes.f551cdbc.jpg";